import React from 'react';

interface SanityMediaAsset {
  _id: string;
}

interface BackgroundImage {
  asset: SanityMediaAsset;
  hotspot: {
    x: number;
    y: number;
  };
  crop: {
    bottom: number;
    left: number;
    right: number;
    top: number;
  };
  alt?: string;
}

interface MarketingContentSection {
  _key: string;
  label: string;
  desktopBackground: BackgroundImage;
  mobileBackground: BackgroundImage;
  content: {
    blocks: [any];
  };
}

interface BlobNavProps {
  marketingContentSections: [MarketingContentSection];
  handleSectionClick: (index: number) => void;
  activeSlide: number;
}

const BlobNav: React.FC<BlobNavProps> = ({
  marketingContentSections,
  handleSectionClick,
  activeSlide,
}) => (
  <div
    className="fixed bottom-0 top-0 h-screen w-6 right-0 lg:right-4 flex flex-col items-center align-middle justify-center gap-3 px-2 z-[3]"
    aria-hidden
  >
    {marketingContentSections?.map((section, index) => (
      <button
        type="button"
        key={section.label}
        onClick={() => {
          handleSectionClick(index);
        }}
        className={`rounded-full flex justify-center items-center ease-in duration-100 shadow-md
          group
          ${
            activeSlide === index ? 'bg-primary w-2 h-6' : 'bg-accent w-2 h-2'
          }`}
      >
        <span className="hidden">{section.label}</span>
      </button>
    ))}
  </div>
);

export default BlobNav;
